// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"657b2031","455":"83855ec6","977":"57200094"}[chunkId] + ".chunk.js";
};